<style>
</style>

<template>
  <div class="row">
    <div class="col-md-12">
      <h3>beoordeling per vraag</h3>
      <div class="row reviewcard" v-for="(row,index) in rows" :key="index">
        <div class="col-md-6 reviewdatum">
          <span class="fa fa-question-circle-o"></span>
          &nbsp;{{ row.vraag }}
        </div>
        <div class="col-md-6 reviewstar">
          <div class="star-ratings-css">
            <span class="star-ratings-css-top" v-bind:style="{width: row.score + '%'}">
             <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
            </span>
            <span class="star-ratings-css-bottom">
             <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
            </span>
          </div>
        </div>

        <div class="col-md-12 reviewtext"></div>
      </div>
      <div class="row margin20">
        <div class="col-md-12"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data: function() {
    return {
      rows: []
    }
  },
  created: function() {
    axios
      .post(
        `OpleidingDetail.aspx/GetPerpersData`,
        {
          CourseID: $('#Perpersapp').data('xcourseid'),
          xsp: $('#Perpersapp').data('xsp')
        },
        {
          headers: { 'Content-Type': 'application/json; charset=utf-8; multipart/form-data;' }
        }
      )
      .then(response => {
        // JSON responses are automatically parsed.
        this.rows = JSON.parse(response.data.d).rows
      })
  }
}
</script>
